export default __webpack_public_path__ + "static/td-ameritrade-logo-c14fc662c849699e418e51286cc4e63e.png";